
import { PromptTestInput, PromptTestOutput } from "@/types/admin";

// Mock implementation - in a real app, this would call an edge function
export const runPromptTest = async (input: PromptTestInput): Promise<PromptTestOutput> => {
  try {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    // Return mock data
    return {
      callScript: "Hello, this is [Dealer Name] calling about your recent inquiry. I noticed you were interested in [Vehicle Model]. Is this still something you're considering?",
      summary: "The lead showed interest in a specific vehicle model last month but didn't follow through with a test drive.",
      intentScore: 0.85,
      modelOutput: JSON.stringify({
        intent: "high",
        reasoning: "Lead has shown specific interest in product, used detailed language indicating genuine interest",
        followup_recommended: true
      }, null, 2)
    };
  } catch (error) {
    console.error("Error running prompt test:", error);
    throw error;
  }
};
